module.exports = __webpack_public_path__ + "img/green.c8411534.png";